module.exports = __webpack_public_path__ + "media/a5.b2487b1a.wav";